import type { SxProps, Theme } from "@mui/material";
import { Card, CardContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { WORKPLACE_REFERRALS_EARNINGS_INFO_MODAL_FULL_PATH } from "../../paths";
import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../../types";

interface ReferralStatItemProps {
  title: string;
  formattedValue: string;
  formattedValueLinkPath: string;
  sx?: SxProps<Theme>;
  showInfoIcon?: boolean;
}

export function ReferralStatItem(props: ReferralStatItemProps) {
  const { title, formattedValue, formattedValueLinkPath, sx, showInfoIcon = false } = props;
  const history = useHistory();

  const handleInfoClick = () => {
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.REFERRAL_STATS_TOOLTIP_CLICKED,
      component: WorkplaceReferralComponent.REFERRAL_DATA_SECTION,
      title,
    });
    history.push(WORKPLACE_REFERRALS_EARNINGS_INFO_MODAL_FULL_PATH);
  };

  return (
    <Card sx={sx}>
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" width="100%">
            <Text bold>{title}</Text>

            {showInfoIcon && (
              <IconButton iconType="info" variant="ghost" size="xSmall" onClick={handleInfoClick} />
            )}

            <IconButton
              iconType="chevron-right"
              variant="ghost"
              size="xSmall"
              sx={{ marginLeft: "auto" }}
              onClick={() => {
                logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
                  action: WorkplaceReferralAction.REFERRAL_STATS_CLICKED,
                  component: WorkplaceReferralComponent.REFERRAL_DATA_SECTION,
                  title,
                  link: formattedValueLinkPath,
                });

                history.push(formattedValueLinkPath);
              }}
            />
          </Stack>

          <Text variant="h4">{formattedValue}</Text>
        </Stack>
      </CardContent>
    </Card>
  );
}
